<template>
  <v-container>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :top="true" :right="true" :timeout="6000">
      {{ message }}
      <v-btn dark text @click="snackbar = false"> CLOSE </v-btn>
    </v-snackbar>
    <v-layout mb-1>
      <v-flex xs12>
        <h2 class="white--text">NCE Reports</h2>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs3> </v-flex>
      <v-spacer> </v-spacer>
      <v-col cols="12" md="2" class="text-lg-right">
        <v-menu offset-y>
<!--          <template v-slot:activator="{ on }">-->
<!--            <v-btn color="secondary" dark v-on="on"-->
<!--            @click="exportToExcel" > Export Report </v-btn>-->
<!--          </template>-->
        </v-menu>
      </v-col>
    </v-layout>
    <v-layout row wrap ml-3>
      <v-flex  fluid fill-height>
        <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="7">
        <v-card raised height="380" width="800" class="right-aligned-chart-item">
          <DxPieChart id="pie" :data-source="growers" palette="Bright" title="Growers Settlement Details Report"
            @point-click="pointClickHandler($event)" @legend-click="legendClickHandler($event)">
            <DxSeries argument-field="grower" value-field="growercount"
            >
              <DxLabel :visible="true">
                <DxConnector :visible="true" :width="1" />
              </DxLabel>
            </DxSeries>
            <DxSize :width="600" />
            <DxExport :enabled="true" />
          </DxPieChart>
        </v-card>
        </v-col>
      </v-row>
      </v-flex>
    </v-layout>
    <v-layout mt-200>
      <v-flex xs12 mt-200>
        <WithoutPayDetailsData  :segmentSelected="segmentSelected" v-show="showGrowerDetails" :key="childComponentKey"></WithoutPayDetailsData>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import config from '../../../config'
import WithoutPayDetailsData from './WithoutPayDetailsData'
import { mapActions } from 'vuex'
import * as XLSX from 'xlsx'
import DxPieChart, {
	DxSize,
	DxSeries,
	DxLabel,
	DxConnector,
	DxExport
} from 'devextreme-vue/pie-chart'

export default {
	name: 'GrowersWithoutSettlementDetailsRpts',
	components: {
		WithoutPayDetailsData,
		DxPieChart,
		DxSize,
		DxSeries,
		DxLabel,
		DxConnector,
		DxExport
	},
	data: function () {
		return {
			message: '',
			snackbar: false,
			countloaded: false,
			snackbarColor: '',
			showGrowerDetails: false,
			noOfAuctionFiles: 0,
			items: [{ name: 'auction', title: 'Auction File', ext: 'xlsx' }],
			growersPendingApprovalCount: 0,
			growersWithSettlementCount: 0,
			growersWithoutSettlementCount: 0,
			growersPendingApproval: [],
			growersWithSettlement: [],
			growersWithoutSettlement: [],
			deadline: '',
			growers: [],
			segmentSelected: null,
			childComponentKey: 0
		}
	},

	mounted () {
		this.getGrowersDetails()
		// WITHDETAILS WITHOUTDETAILS PENDINGAPPROVAL
		//  console.log(this.getGrowerPayStatusDetails('WITHDETAILS'))
		//  console.log(this.getGrowerPayStatusDetails('WITHOUTDETAILS'))
		//  console.log(this.getGrowerPayStatusDetails('PENDINGAPPROVAL'))
	},
	computed: {
		todaysDate: function () {
			const now = new Date()
			const options = {
				day: 'numeric',
				month: 'short',
				weekday: 'long',
				year: 'numeric'
			}
			return now.toLocaleString('en-us', options)
		},
		...mapActions({
			getNceTimeline: 'auction/getNceTimeline'
		})
	},
	methods: {
		exportToExcel () {
			const jsonData = this.growersWithoutSettlement

			// Convert JSON array to worksheet
			const ws = XLSX.utils.json_to_sheet(jsonData)

			// Create a workbook and add the worksheet
			const wb = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(wb, ws, 'Coffee-DSS-Report')

			// Save the Excel file
			XLSX.writeFile(wb, 'Growers-Without-Settlement-Details-Report-' + Date.now() + '.xlsx')
		},
		showGrowerDetailsTab () {
			this.showGrowerDetails = true
		},
		passClickedType (e) {
			const arg = e.target
			// console.log(arg.data.trantype);
		},
		pointClickHandler (e) {
			const arg = e.target
			this.segmentSelected = arg.data.trantype
			this.childComponentKey += 1
			this.showGrowerDetailsTab()
		},
		legendClickHandler (e) { },

		getGrowersDetails () {
			const token = localStorage.getItem('token')
			const tokenconfig = { headers: { Authorization: `Bearer ${token}` } }
			const id = 1
			const withDet = config.serverURI + '/reports/findAllGrowersWithSettlementDetails'
			const withoutDet =
        config.serverURI + '/reports/findAllGrowersWithoutSettlementDetails'
			const pendingApprov = config.serverURI + '/reports/findAllGrowersWithSettlementDetailsByStatus'

			const withSettlementDetails = axios.post(withDet, { tokenconfig })
			const withoutSettlementDetails = axios.post(withoutDet, { tokenconfig })
			const pendingApproval = axios.post(pendingApprov, { id, tokenconfig })

			axios
				.all([withSettlementDetails, withoutSettlementDetails, pendingApproval])
				.then(
					axios.spread((...responses) => {
						const responsewithDet = responses[0]
						const responsewithoutDet = responses[1]
						// const responespendingApprov = responses[2]
						this.growersWithoutSettlement = responsewithoutDet.data
						// console.log("responsewithDet", responsewithDet);
						// console.log("responsewithoutDet", responsewithoutDet);
						// console.log("responespendingApprov", responespendingApprov);
						this.growers = [
							{
								grower: 'Growers With Settlement Details',
								growercount: Object.keys(responsewithDet.data).length,
								trantype: 'WITHDETAILS',
								growerpayDetails: responsewithDet.data
							},
							{
								grower: 'Growers Without Settlement Details',
								growercount: Object.keys(responsewithoutDet.data).length,
								trantype: 'WITHOUTDETAILS',
								growerpayDetails: responsewithoutDet.data
							}
							// {
							// 	grower: 'Pending Approval Growers',
							// 	growercount: Object.keys(responespendingApprov.data).length,
							// 	trantype: 'PENDINGAPPROVAL',
							// 	growerpayDetails: responespendingApprov.data
							// }
						]
					})
				)
				.catch((errors) => {
					console.log(errors)
				})
		}

	}
}
</script>
<style>
.right-aligned-chart {
  float: right;
  /* display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; */
}
.right-aligned-chart-item {
  float: center;
  /* display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; */
}
</style>
